export enum InviteStatus {
  created = 0,
  sent = 1,
  partiallyCompleted = 3,
  completed = 4,
  declined = 5,
  reminderSent = 6,
  completeManually = 7,
  inactive = 8,
  reviewed = 9,
}